export default "__VITE_ASSET__M5g_fJU7__"